import styled from "styled-components";


const StyledButtonRounded = styled.button`

  display: flex;
  border: none;
  min-width: 18px;
  width: auto;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;

  background-color: transparent;

  transition: all 0.3s;

  &:hover {
    background-color: #F7F8FC !important;
  }

  cursor: pointer;
`

const StyledNumberButton = styled(StyledButtonRounded)`
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  padding: 6px;
  min-width: 18px;
  width: auto;
`

const SytledDotButton = styled(StyledButtonRounded)`

  background-color: #F7F8FC !important;

  cursor: default;
`

export {
  StyledButtonRounded,
  StyledNumberButton,
  SytledDotButton
}